module.exports = __webpack_public_path__ + "img/banner.e5641b49.png";